import { Scrollbox } from 'pixi-scrollbox';
import { isMobile } from '../../helpers/isMobile';
import { PixiBase } from '../../core/pixi/PixiBase';
import { containerNames } from '../../constants';
import { gameStore } from '../../store/gameStore';
import { boostedJackpotStore } from '../../store/boostedJackpotStore';
import { userInfoStore } from '../../store/userInfoStore';
import { gameMainDrawer } from './gameMainDrawer';
import { BOOSTED_JACKPOT_KEYS } from '../../enums/gameRules';
import { setTranslationValues } from '../../core/helpers';
import { isoStandard } from '../../helpers/isoStandard';
import { betBarStore } from '../../store/betBarStore';
import { canvasTranslationKeys } from '../../enums';
import { spinBarStore } from '../../store/spinBarStore';

export class BoostedInfoDrawer {
  constructor() {
    this.BoostedInfoContainer = PixiBase.createContainer(containerNames.BoostedInfoContainer);
    this.BoostedInfoContainer.visible = false;
    this.ScrollBoxContainer = PixiBase.createContainer(containerNames.ScrollBoxContainer);
    PixiBase.setupButtonMode(this.BoostedInfoContainer, { interactive: true, buttonMode: true });
    PixiBase.setPosition(this.BoostedInfoContainer, {
      x: isMobile() ? 27 : 489,
      y: isMobile() ? 200 : 86,
    });
    this.yPosition = 0;
    this.styles = {
      wordWrap: true,
      fontWeight: 700,
      align: 'center',
      wordWrapWidth: 206,
      fontFamily: 'Arial',
    };
  }

  setupBlackLayerGraphics() {
    const graphics = PixiBase.createGraphics();
    this.graphics = graphics;
    graphics.beginFill('black');
    graphics.alpha = 0.7;
    graphics.interactive = true;
    graphics.drawRect(
      isMobile() ? -27 : -489,
      isMobile() ? -200 : -86,
      isMobile() ? 540 : 1440,
      isMobile() ? 960 : 810
    );
    graphics.endFill();
    this.BoostedInfoContainer.addChild(this.graphics);
  }

  handleCustomScrollBar(scrollBox) {
    const { scrollbar } = scrollBox;
    scrollbar.clear();
    const scrollPercent =
      scrollBox.scrollTop / (scrollBox.content.height - scrollBox.options.boxHeight);
    const maxScroll = scrollBox.options.boxHeight - 150;
    const currentPosition = scrollPercent * maxScroll;
    scrollbar.beginFill(0xffffff, 0.5);
    scrollbar.interactive = false;
    scrollbar.drawRoundedRect(455, currentPosition + 60, 6, 60, 20);
    scrollbar.endFill();
    scrollBox.content.x = 0;
    scrollBox.scrollbar.endFill();
  }

  setupScrollBox() {
    const scrollBox = new Scrollbox({
      overflowY: 'scroll',
      overflowX: 'hidden',
      scrollbarSize: 10,
      scrollbarOffsetVertical: 5,
      scrollbarBackgroundAlpha: 0,
      boxWidth: 455,
      boxHeight: 635,
    });
    PixiBase.setPosition(scrollBox, { x: 20 });
    scrollBox.content.addChild(this.ScrollBoxContainer);
    scrollBox.content.screenWidth = isMobile() ? 540 : 1000;
    scrollBox.content.screenHeight = 610;
    scrollBox.update();
    scrollBox.content.interactive = true;
    scrollBox.content.interactiveChildren = true;
    this.handleCustomScrollBar(scrollBox);
    scrollBox.content.addEventListener('moved', () => {
      this.handleCustomScrollBar(scrollBox);
      scrollBox.content.x = 0;
    });
    this.BoostedInfoContainer.addChild(scrollBox);
  }

  setupBackgroundPopup() {
    const BackgroundPopupContainer = PixiBase.createContainer(
      containerNames.BackgroundPopupContainer
    );
    const popupUI = PixiBase.createSprite(this.spriteSheet.boostedJackpotInfoPopupUI);
    const popupBackground = PixiBase.createSprite(this.spriteSheet.boostedJackpotInfoPopup);
    popupUI.anchor.set(0);
    popupBackground.anchor.set(0);
    PixiBase.setPosition(popupUI, { x: 5, y: 60 });
    BackgroundPopupContainer.addChild(popupBackground);
    this.ScrollBoxContainer.addChild(popupUI);
    this.BoostedInfoContainer.addChild(BackgroundPopupContainer);
  }

  setupTitle() {
    const TitleContainer = PixiBase.createContainer(containerNames.TitleContainer);
    PixiBase.setPosition(TitleContainer, { x: 224, y: 30 });
    const infoTitle = PixiBase.createText(gameStore.canvasTranslationKeys.BOOSTED_JACKPOT, {
      ...this.styles,
      fontSize: 18,
      fill: '#FFFFFF',
      fontWeight: 600,
    });
    infoTitle.anchor.set(0.5);
    TitleContainer.addChild(infoTitle);
    this.ScrollBoxContainer.addChild(TitleContainer);
  }

  setupCloseButton() {
    const CloseButtonContainer = PixiBase.createContainer(containerNames.CloseButtonContainer);
    PixiBase.setPosition(CloseButtonContainer, {
      x: 438,
      y: 12,
    });
    const closeButton = PixiBase.createSprite(this.spriteSheet.boostedJackpotPopupCloseButton);
    PixiBase.setupButtonMode(CloseButtonContainer, { interactive: true, buttonMode: true });
    PixiBase.registerClick(CloseButtonContainer, () => {
      this.BoostedInfoContainer.visible = false;
      spinBarStore.setIsSpinStart(false);
    });
    closeButton.anchor.set(0);
    closeButton.scale.set(1.1);
    CloseButtonContainer.addChild(closeButton);
    this.BoostedInfoContainer.addChild(CloseButtonContainer);
  }

  setupWinnersCount() {
    const WinnersCountContainer = PixiBase.createContainer(containerNames.WinnersCountContainer);
    PixiBase.setPosition(WinnersCountContainer, { x: 70, y: 100 });
    const winnersTitle = PixiBase.createText(gameStore.canvasTranslationKeys.WINNING_COUNT, {
      ...this.styles,
      fontSize: 10,
      fill: '#FFFFFF',
    });
    winnersTitle.anchor.set(0.5);
    const winnersCount = PixiBase.createText(boostedJackpotStore.winningCount, {
      ...this.styles,
      fontSize: 20,
      fill: '#FFC33E',
    });
    winnersCount.anchor.set(0.5);
    PixiBase.setPosition(winnersCount, { x: 0, y: 25 });
    WinnersCountContainer.addChild(winnersTitle);
    WinnersCountContainer.addChild(winnersCount);
    this.ScrollBoxContainer.addChild(WinnersCountContainer);
  }

  setupWinnersLeftCount() {
    const WinnersLeftCountContainer = PixiBase.createContainer(
      containerNames.WinnersLeftCountContainer
    );
    PixiBase.setPosition(WinnersLeftCountContainer, { x: 380, y: 100 });
    const winnersLeftTitle = PixiBase.createText(
      gameStore.canvasTranslationKeys.WINNERS_COUNT_LEFT,
      { ...this.styles, fontSize: 10, fill: '#FFFFFF' }
    );
    winnersLeftTitle.anchor.set(0.5);
    this.winnersLeftCount = PixiBase.createText(boostedJackpotStore.winningCountLeft, {
      ...this.styles,
      fontSize: 20,
      fill: '#FFC33E',
    });
    this.winnersLeftCount.anchor.set(0.5);
    PixiBase.setPosition(this.winnersLeftCount, { x: 0, y: 25 });
    WinnersLeftCountContainer.addChild(winnersLeftTitle);
    WinnersLeftCountContainer.addChild(this.winnersLeftCount);
    this.ScrollBoxContainer.addChild(WinnersLeftCountContainer);
  }

  setupPrizePull() {
    const PrizePullContainer = PixiBase.createContainer(containerNames.PrizePullContainer);
    const prizePoolTitle = PixiBase.createText(gameStore.canvasTranslationKeys.PRIZE_POOL, {
      ...this.styles,
      fontSize: 10,
      fill: '#FFFFFF',
    });
    PixiBase.setPosition(prizePoolTitle, { x: 223, y: 165 });
    prizePoolTitle.anchor.set(0.5);
    const prizePoolAmount = PixiBase.createText(
      `${isoStandard(boostedJackpotStore.prizePoolAmount)} ${userInfoStore.currencySymbolOrCode}`,
      {
        fontWeight: 700,
        align: 'center',
        fontFamily: 'Arial',
        fontSize: 40,
        fill: '#FFC33E',
      }
    );
    prizePoolAmount.anchor.set(0.5);
    PixiBase.setPosition(prizePoolAmount, { x: 223, y: 205 });
    PrizePullContainer.addChild(prizePoolTitle);
    PrizePullContainer.addChild(prizePoolAmount);
    this.ScrollBoxContainer.addChild(PrizePullContainer);
  }

  setupPrizePullLeft() {
    const PrizePullLeftContainer = PixiBase.createContainer(containerNames.PrizePullLeftContainer);
    const prizePoolLeftTitle = PixiBase.createText(
      gameStore.canvasTranslationKeys.PRIZE_POOL_LEFT,
      { ...this.styles, fontSize: 10, fill: '#FFFFFF' }
    );
    prizePoolLeftTitle.anchor.set(0.5);
    PixiBase.setPosition(prizePoolLeftTitle, { x: 225, y: 243 });
    this.prizePoolLeftAmount = PixiBase.createText(
      `${isoStandard(boostedJackpotStore.prizePoolLeftAmount)} ${
        userInfoStore.currencySymbolOrCode
      }`,
      {
        ...this.styles,
        fontSize: 20,
        fill: '#FFC33E',
      }
    );
    this.prizePoolLeftAmount.anchor.set(0.5);
    PixiBase.setPosition(this.prizePoolLeftAmount, { x: 225, y: 270 });
    PrizePullLeftContainer.addChild(prizePoolLeftTitle);
    PrizePullLeftContainer.addChild(this.prizePoolLeftAmount);
    this.ScrollBoxContainer.addChild(PrizePullLeftContainer);
  }

  formattedDate(value) {
    if (!value) return '';
    const date = new Date(value);
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).format(date);
  }

  setupLastWinner() {
    const LastWinnerContainer = PixiBase.createContainer(containerNames.LastWinnerContainer);
    const lastWinnerTitle = PixiBase.createText(gameStore.canvasTranslationKeys.LAST_WINNER, {
      ...this.styles,
      fontSize: 10,
      fill: '#FFFFFF',
    });
    lastWinnerTitle.anchor.set(0.5);
    PixiBase.setPosition(lastWinnerTitle, { x: 100, y: 303 });
    this.lastWinnerAmount = PixiBase.createText(
      `${isoStandard(boostedJackpotStore.lastWinnerAmount)} ${userInfoStore.currencySymbolOrCode}`,
      {
        ...this.styles,
        fontSize: 20,
        fill: '#FFC33E',
      }
    );
    this.lastWinnerAmount.anchor.set(0.5);
    PixiBase.setPosition(this.lastWinnerAmount, { x: 100, y: 335 });
    this.lastWinnerDate = PixiBase.createText(
      this.formattedDate(boostedJackpotStore.lastWinnerDate),
      { ...this.styles, fontSize: 10, fill: '#FFFFFF' }
    );
    this.lastWinnerDate.anchor.set(0.5);
    PixiBase.setPosition(this.lastWinnerDate, { x: 100, y: 350 });
    LastWinnerContainer.addChild(this.lastWinnerDate);
    LastWinnerContainer.addChild(lastWinnerTitle);
    LastWinnerContainer.addChild(this.lastWinnerAmount);
    this.ScrollBoxContainer.addChild(LastWinnerContainer);
  }

  updateDataInfoPopup({
    lastWin,
    largestWin,
    lastWinDate,
    leftWinsCount,
    leftPoolSize,
    largestWinDate,
  }) {
    this.lastWinnerDate.text = this.formattedDate(lastWinDate);
    this.lastWinnerAmount.text = `${isoStandard(lastWin)} ${userInfoStore.currencySymbolOrCode}`;
    this.largestWinnerAmount.text = `${isoStandard(largestWin)} ${
      userInfoStore.currencySymbolOrCode
    }`;
    this.winnersLeftCount.text = leftWinsCount;
    this.largestWinnerDate.text = this.formattedDate(largestWinDate);
    this.prizePoolLeftAmount.text = `${isoStandard(leftPoolSize)} ${
      userInfoStore.currencySymbolOrCode
    }`;
  }

  setupLargestWinner() {
    const LargestWinnerContainer = PixiBase.createContainer(containerNames.LargestWinnerContainer);
    const largestWinnerTitle = PixiBase.createText(gameStore.canvasTranslationKeys.LARGEST_WINNER, {
      ...this.styles,
      fontSize: 10,
      fill: '#FFFFFF',
    });
    largestWinnerTitle.anchor.set(0.5);
    PixiBase.setPosition(largestWinnerTitle, { x: 350, y: 303 });
    this.largestWinnerAmount = PixiBase.createText(
      `${isoStandard(boostedJackpotStore.largestWinnerAmount)} ${
        userInfoStore.currencySymbolOrCode
      }`,
      {
        ...this.styles,
        fontSize: 20,
        fill: '#FFC33E',
      }
    );
    this.largestWinnerAmount.anchor.set(0.5);
    PixiBase.setPosition(this.largestWinnerAmount, { x: 350, y: 335 });
    this.largestWinnerDate = PixiBase.createText(
      this.formattedDate(boostedJackpotStore.largestWinnerDate),
      { ...this.styles, fontSize: 10, fill: '#FFFFFF' }
    );
    this.largestWinnerDate.anchor.set(0.5);
    PixiBase.setPosition(this.largestWinnerDate, { x: 350, y: 350 });
    LargestWinnerContainer.addChild(this.largestWinnerDate);
    LargestWinnerContainer.addChild(largestWinnerTitle);
    LargestWinnerContainer.addChild(this.largestWinnerAmount);
    this.ScrollBoxContainer.addChild(LargestWinnerContainer);
  }

  setupEndsInDate() {
    const EndsInDateContainer = PixiBase.createContainer(containerNames.EndsInDateContainer);
    const endsInDateTitle = PixiBase.createText('ENDS IN', {
      ...this.styles,
      fontSize: 10,
      fill: '#FFFFFF',
    });
    endsInDateTitle.anchor.set(0);
    PixiBase.setPosition(endsInDateTitle, { x: 203, y: 372 });
    this.infoBoostedJackpotDateHeader = gameMainDrawer.boostedJackpot.setupBoostedJackpotDateHeader(
      {
        x: 100,
        y: 434,
        marginX: 75,
        parent: EndsInDateContainer,
        styles: { ...this.styles, fontSize: 10, fill: '#FFFFFF' },
      }
    );
    gameMainDrawer.boostedJackpot.setupBoostedJackpotPopupDate({
      x: 93,
      y: 397,
      marginX: 73,
      parent: EndsInDateContainer,
      styles: { ...this.styles, fontSize: 24, fill: '#FFFFFF', letterSpacing: 19 },
    });
    EndsInDateContainer.addChild(endsInDateTitle);
    this.ScrollBoxContainer.addChild(EndsInDateContainer);
  }

  setupIntroTitle() {
    const IntroTitleContainer = PixiBase.createContainer(containerNames.IntroTitleContainer);
    PixiBase.setPosition(IntroTitleContainer, { x: 225, y: 485 });
    const introTitle = PixiBase.createText(gameStore.canvasTranslationKeys.RULES, {
      ...this.styles,
      fontSize: 18,
      fill: '#FFFFFF',
      fontWeight: 600,
    });
    introTitle.anchor.set(0.5);
    IntroTitleContainer.addChild(introTitle);
    this.ScrollBoxContainer.addChild(IntroTitleContainer);
  }

  setupIntroTexts() {
    let start = 0;
    const IntroTextsContainer = PixiBase.createContainer(containerNames.IntroTextsContainer);
    PixiBase.setPosition(IntroTextsContainer, { x: 0, y: 550 });
    [...BOOSTED_JACKPOT_KEYS].forEach(({ key, type, isSprite }) => {
      const IntroItemContainer = PixiBase.createContainer(containerNames.IntroItemContainer);
      const textValue = key
        ? setTranslationValues(
            `${gameStore.canvasTranslationKeys[key]} ${
              key === canvasTranslationKeys.RULES_DESCRIPTION_2 ? userInfoStore.currencySymbol : ''
            }`,
            {
              VALUE: isoStandard(betBarStore.limits.boostedJackpotBetAmount),
            }
          )
        : '';
      const text = PixiBase.createText(textValue, {
        fontSize: type === 'title' ? 17 : 15,
        fontWeight: type === 'title' ? 700 : 400,
        fontFamily: 'Arial',
        fill: type === 'title' ? '#FFC33E' : '#FFFFFFE5',
        wordWrap: true,
        wordWrapWidth: 450,
      });

      if (isSprite) {
        const icons = PixiBase.createSprite(this.spriteSheet.rulesIcons);
        icons.x = 105;
        icons.y = Math.ceil(start - 20);
        IntroItemContainer.addChild(icons);
        start += 30;
      }
      text.y = Math.ceil(start);
      IntroItemContainer.addChild(text);
      IntroTextsContainer.addChild(IntroItemContainer);
      start = text.y + text.height + (type === 'title' ? 15 : 10);
      this.ScrollBoxContainer.addChild(IntroTextsContainer);
    });
  }

  executeBoostedInfoData() {
    this.setupBlackLayerGraphics();
    this.setupBackgroundPopup();
    this.setupScrollBox();
    this.setupTitle();
    this.setupCloseButton();
    this.setupWinnersCount();
    this.setupWinnersLeftCount();
    this.setupPrizePull();
    this.setupPrizePullLeft();
    this.setupLastWinner();
    this.setupLargestWinner();
    this.setupEndsInDate();
    this.setupIntroTitle();
    this.setupIntroTexts();
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
  }
}
